import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import ar from "./locales/ar.json";
import enExtra from "./locales/en.extra.json";
import arExtra from "./locales/ar.extra.json";
import enBilling from "./locales/en.billing.json";
import arBilling from "./locales/ar.billing.json";
import enWallet from "./locales/en.wallet.json";
import arWallet from "./locales/ar.wallet.json";
import enBranch from "./locales/en.branch.json";
import arBranch from "./locales/ar.branch.json";
import enHr from "./locales/en.hr.json";
import arHr from "./locales/ar.hr.json";
import enPersonal from "./locales/en.personal.json";
import arPersonal from "./locales/ar.personal.json";
import enDuty from "./locales/en.duty.json";
import arDuty from "./locales/ar.duty.json";
import enFeatures from "./locales/en.features.json";
import arFeatures from "./locales/ar.features.json";
import enSales from "./locales/en.sales.json";
import arSales from "./locales/ar.sales.json";
import enAcct from "./locales/en.acct.json";
import arAcct from "./locales/ar.acct.json";
import enCapacity from "./locales/en.capacity.json";
import arCapacity from "./locales/ar.capacity.json";
import enSalaryReport from "./locales/en.salaryReport.json";
import arSalaryReport from "./locales/ar.salaryReport.json";
import enPayrollArchive from "./locales/en.payrollArchive.json";
import arPayrollArchive from "./locales/ar.payrollArchive.json";
import enPenalty from "./locales/en.penalty.json";
import arPenalty from "./locales/ar.penalty.json";
import enKpi from "./locales/en.kpi.json";
import arKpi from "./locales/ar.kpi.json";
import enBonus from "./locales/en.bonus.json";
import arBonus from "./locales/ar.bonus.json";
import enPurchases from "./locales/en.purchases.json";
import arPurchases from "./locales/ar.purchases.json";
import enDues from "./locales/en.dues.json";
import arDues from "./locales/ar.dues.json";
import enSettlements from "./locales/en.settlements.json";
import arSettlements from "./locales/ar.settlements.json";
import enTasks from "./locales/en.tasks.json";
import arTasks from "./locales/ar.tasks.json";
import { deepMerge } from "./deepMerge";

export const LANGS = ["ar", "en"];

const EN = deepMerge(en, enExtra, enBilling, enWallet, enBranch, enHr, enPersonal, enDuty, enFeatures, enAcct, enCapacity, enSalaryReport, enPayrollArchive, enSales, enPenalty, enKpi, enBonus, enPurchases, enDues, enSettlements, enTasks);
const AR = deepMerge(ar, arExtra, arBilling, arWallet, arBranch, arHr, arPersonal, arDuty, arFeatures, arAcct, arCapacity, arSalaryReport, arPayrollArchive, arSales, arPenalty, arKpi, arBonus, arPurchases, arDues, arSettlements, arTasks);

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: EN },
    ar: { translation: AR },
  },
  lng: localStorage.getItem("lang") || "ar",
  fallbackLng: "en",
  // Golden rule: digits are always Latin, in every language.
  interpolation: { escapeValue: false, format: (value) => (typeof value === "number" ? String(value) : value) },
});

export const applyDirection = (lang) => {
  document.documentElement.lang = lang;
  document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
};

applyDirection(i18n.language);

export default i18n;
